export const BusCharterIcon = () => (
  <svg width="30" height="30" viewBox="0 0 24 24" fill="currentColor">
    <path d="M18 11H6V6H18V11ZM17 1H7C5.9 1 5 1.9 5 3V20C5 21.1 5.9 22 7 22H8C8 22.55 8.45 23 9 23C9.55 23 10 22.55 10 22H14C14 22.55 14.45 23 15 23C15.55 23 16 22.55 16 22H17C18.1 22 19 21.1 19 20V3C19 1.9 18.1 1 17 1ZM17 19H7V16H17V19ZM17 14H7V3H17V14Z" />
  </svg>
);

export const SubscriptionBusIcon = () => (
  <svg width="25" height="25" viewBox="0 0 24 24" fill="currentColor">
    <path d="M4 16C4 16.88 4.39 17.67 5 18.22V20C5 20.55 5.45 21 6 21H7C7.55 21 8 20.55 8 20V19H16V20C16 20.55 16.45 21 17 21H18C18.55 21 19 20.55 19 20V18.22C19.61 17.67 20 16.88 20 16V6C20 2.5 16.42 2 12 2C7.58 2 4 2.5 4 6V16ZM7.5 17C6.67 17 6 16.33 6 15.5C6 14.67 6.67 14 7.5 14C8.33 14 9 14.67 9 15.5C9 16.33 8.33 17 7.5 17ZM16.5 17C15.67 17 15 16.33 15 15.5C15 14.67 15.67 14 16.5 14C17.33 14 18 14.67 18 15.5C18 16.33 17.33 17 16.5 17ZM18 11H6V6H18V11Z" />
    <path d="M12.5 12H11.5V14H10.5V12H9.5V11H10.5V9H11.5V11H12.5V12Z" />
  </svg>
);

export const VendorBusingSubscriptionIcon = () => (
  <svg width="35" height="35" viewBox="0 0 24 24" fill="currentColor">
    <path d="M4 16C4 16.88 4.39 17.67 5 18.22V20C5 20.55 5.45 21 6 21H7C7.55 21 8 20.55 8 20V19H16V20C16 20.55 16.45 21 17 21H18C18.55 21 19 20.55 19 20V18.22C19.61 17.67 20 16.88 20 16V6C20 2.5 16.42 2 12 2C7.58 2 4 2.5 4 6V16ZM7.5 17C6.67 17 6 16.33 6 15.5C6 14.67 6.67 14 7.5 14C8.33 14 9 14.67 9 15.5C9 16.33 8.33 17 7.5 17ZM16.5 17C15.67 17 15 16.33 15 15.5C15 14.67 15.67 14 16.5 14C17.33 14 18 14.67 18 15.5C18 16.33 17.33 17 16.5 17ZM18 11H6V6H18V11Z" />
    <path d="M16 1H8V3H16V1Z" />
    <path d="M12 13C13.66 13 15 11.66 15 10C15 8.34 13.66 7 12 7C10.34 7 9 8.34 9 10C9 11.66 10.34 13 12 13Z" />
  </svg>
);

export const KidsManagementIcon = () => (
  <svg width="25" height="25" viewBox="0 0 24 24" fill="currentColor">
    <path d="M16.5 12C17.88 12 18.99 10.88 18.99 9.5C18.99 8.12 17.88 7 16.5 7C15.12 7 14 8.12 14 9.5C14 10.88 15.12 12 16.5 12ZM9 11C10.66 11 11.99 9.66 11.99 8C11.99 6.34 10.66 5 9 5C7.34 5 6 6.34 6 8C6 9.66 7.34 11 9 11ZM16.5 14C14.67 14 11 14.92 11 16.75V19H22V16.75C22 14.92 18.33 14 16.5 14ZM9 13C6.67 13 2 14.17 2 16.5V19H9V16.75C9 15.9 9.33 14.41 11.37 13.28C10.5 13.1 9.66 13 9 13Z" />
    <path d="M16.5 12C17.88 12 18.99 10.88 18.99 9.5C18.99 8.12 17.88 7 16.5 7C15.12 7 14 8.12 14 9.5C14 10.88 15.12 12 16.5 12Z" />
  </svg>
);

export const KidsGroupIcon = () => (
  <svg width="25" height="25" viewBox="0 0 24 24" fill="currentColor">
    <path d="M16 4C16 2.89 16.89 2 18 2C19.11 2 20 2.89 20 4C20 5.11 19.11 6 18 6C16.89 6 16 5.11 16 4ZM20 22V16H22.5L20 8H18L15.5 16H18V22H20ZM12.5 11.5C13.33 11.5 14 10.83 14 10C14 9.17 13.33 8.5 12.5 8.5C11.67 8.5 11 9.17 11 10C11 10.83 11.67 11.5 12.5 11.5ZM5.5 6C6.61 6 7.5 5.11 7.5 4C7.5 2.89 6.61 2 5.5 2C4.39 2 3.5 2.89 3.5 4C3.5 5.11 4.39 6 5.5 6ZM7.5 22V15H9V9C9 7.9 8.1 7 7 7H4C2.9 7 2 7.9 2 9V15H3.5V22H7.5ZM14 22V18H15V14C15 13.18 14.36 12.46 13.55 12.31C13.21 12.25 12.86 12.26 12.53 12.34C11.69 12.56 11.12 13.36 11.14 14.23L11 18V22H14Z" />
  </svg>
);

export const ReservationIcon = () => (
  <svg width="25" height="25" viewBox="0 0 24 24" fill="currentColor">
    <path d="M19 3H18V1H16V3H8V1H6V3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V8H19V19Z" />
    <path d="M7 10H9V12H7V10Z" />
    <path d="M11 10H13V12H11V10Z" />
    <path d="M15 10H17V12H15V10Z" />
    <path d="M7 14H9V16H7V14Z" />
    <path d="M11 14H13V16H11V14Z" />
    <path d="M15 14H17V16H15V14Z" />
  </svg>
);

export const ScheduleReservationIcon = () => (
  <svg width="25" height="25" viewBox="0 0 24 24" fill="currentColor">
    <path d="M19 3H18V1H16V3H8V1H6V3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V8H19V19Z" />
    <path d="M9 10H7V12H9V10Z" />
    <path d="M13 10H11V12H13V10Z" />
    <path d="M17 10H15V12H17V10Z" />
    <path d="M9 14H7V16H9V14Z" />
    <path d="M13 14H11V16H13V14Z" />
    <path d="M17 14H15V16H17V14Z" />
    <path d="M8 2H10V4H8V2Z" />
    <path d="M14 2H16V4H14V2Z" />
  </svg>
);

export const CancelReservationIcon = () => (
  <svg width="25" height="25" viewBox="0 0 24 24" fill="currentColor">
    <path d="M19 3H18V1H16V3H8V1H6V3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V8H19V19Z" />
    <path d="M15.5 10L12 13.5L8.5 10L7.5 11L11 14.5L7.5 18L8.5 19L12 15.5L15.5 19L16.5 18L13 14.5L16.5 11L15.5 10Z" />
  </svg>
);

export const RidesCompletedIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <path d="M18 8H17V6C17 3.24 14.76 1 12 1S7 3.24 7 6V8H6C4.9 8 4 8.9 4 10V20C4 21.1 4.9 22 6 22H18C21.1 22 22 21.1 22 20V10C22 8.9 21.1 8 18 8ZM12 3C13.66 3 15 4.34 15 6V8H9V6C9 4.34 10.34 3 12 3ZM18 20H6V10H18V20ZM12 17C13.1 17 14 16.1 14 15C14 13.9 13.1 13 12 13S10 13.9 10 15C10 16.1 10.9 17 12 17Z" />
    <path d="M12 19C13.1 19 14 18.1 14 17C14 15.9 13.1 15 12 15S10 15.9 10 17C10 18.1 10.9 19 12 19Z" />
  </svg>
);

export const CompletedJourneyIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" />
    <path d="M16.59 7.58L10 14.17l-2.59-2.58L6 13l4 4 8-8z" />
    <path d="M17 7H7V5H17V7Z" />
    <path d="M17 10H7V8H17V10Z" />
    <path d="M17 13H7V11H17V13Z" />
    <path d="M17 16H7V14H17V16Z" />
  </svg>
);
